import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'HandMoveIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hand-move",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M2.541 5.594a13.487 13.487 0 0 1 2.46 -1.427"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 3.458c1.32 .354 2.558 .902 3.685 1.612"
    }, null), _createTextVNode(" ")]);
  }
};